import { useLpConfig } from "routes/LandingPage/LpConfigContext";

/**
 * ランディングページのフッターセクション
 * ロゴ、ナビゲーションリンク、コピーライトを表示する。`showFollowUs: false` なら「Follow us」を出さない
 * @return {JSX.Element} フッターコンポーネント
 */
export function LpFooter() {
  const lpConfig = useLpConfig();
  return (
    <footer className="bg-[#0F1649] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Column 1: Logo & Description */}
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/images/strix_search_top_logo1.png`}
              alt="StrixSearch"
              className="h-8"
            />
            <p className="text-sm text-gray-400 mt-4">
              {lpConfig.footer.tagline}
            </p>
          </div>

          {/* Navigation Columns */}
          {lpConfig.footer.columns.map(column => (
            <div key={column.heading}>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
                {column.heading}
              </h4>
              <ul className="space-y-3">
                {column.links.map(link => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 mt-8 flex justify-between items-center">
          <p className="text-sm text-gray-500">{lpConfig.footer.copyright}</p>
          {lpConfig.footer.showFollowUs !== false && (
            <div className="flex items-center gap-4 text-gray-500">
              <span className="text-sm">Follow us</span>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}
